import { memo } from 'react';

import { Flex } from '@chakra-ui/react';

import { Button } from 'ui';

interface NavigationButtonsProps {
  onBackHandler?: () => void;
  onNextHandler?: () => void;
  nextLabel?: string;
  backLabel?: string;
  isDisabled?: boolean;
}
const NavigationButtons = ({
  onBackHandler,
  onNextHandler = () => {},
  nextLabel = '',
  backLabel = '',
  isDisabled = false
}: NavigationButtonsProps) => (
  <Flex
    justifyContent='center'
    direction={{ base: 'column-reverse', lg: 'row' }}
    alignItems='center'
    gap='20px'
    mt={['47px', '50px']}
    flexWrap='wrap'
  >
    {Boolean(backLabel) && (
      <Button variant='outline' w='272px' h='45px' onClick={onBackHandler}>
        {backLabel}
      </Button>
    )}

    {Boolean(nextLabel) && (
      <Button
        w='272px'
        h='45px'
        onClick={onNextHandler}
        isDisabled={isDisabled}
      >
        {nextLabel}
      </Button>
    )}
  </Flex>
);

export default memo(NavigationButtons);
